module.exports = __webpack_public_path__ + "img/Chargify.9bb71fba.svg";